<template>
    <VContainer>
        <VCard>
            <VCardTitle>
                My Registrations {{this.event.name}}
            </VCardTitle>
            <VCardText>
                <DoublesCard  v-for="(r,i) in registrations" :key="i" :p1="r[0]" :p2="r[1]" :regdata="regdata" @player1="openCard($event)" @player2="openCard($event)"  />
            </VCardText>
        </VCard>
        <VDialog v-model="playercarddialog" max-width="600">
            <VCard>
                <VCardTitle>
                    <VAvatar size="60" @click="cropperdialog=true">
                       <VImg :src="activeregistrant['profile.profilepic']" />
                    </VAvatar>
                    <span class="ml-2">
                       {{activeregistrant['profile.firstname']}} {{activeregistrant['profile.lastname']}}
                    </span>
                </VCardTitle>
                <VCardText>
                    <VSelect
                        :items="sizes"
                        label="Shirt size"
                        v-model="shirtsize"
                        outlined
                    ></VSelect>
                    <VTextField
                            outlined
                            label="AVP Number"
                            v-model="avpnumber"
                    ></VTextField>
                    <VTextField
                            v-model="cellphone"
                            autocomplete
                            outlined
                            label="Cell Phone"
                            :rules="[$store.state.rules.cellRules]"
                    />
                </VCardText>
                <VCardActions>
                    <BaseBtn @click="playercarddialog=false">Close</BaseBtn>
                    <v-spacer></v-spacer>
                    <BaseBtn @click="saveData()" :loading="loading">Save</BaseBtn>
                </VCardActions>
            </VCard>
        </VDialog>
        <!--<VDialog v-model="cropperdialog" max-width="500" >-->
            <!--<VCard>-->
                <!--<VCardTitle>-->
                    <!--Profile Pic-->
                <!--</VCardTitle>-->
                <!--<VCardText>-->
                    <!--<ImageCropper />-->
                <!--</VCardText>-->
                <!--<VCardActions>-->
                    <!--<BaseBtn @click="cropperdialog=false">Close</BaseBtn>-->
                <!--</VCardActions>-->
            <!--</VCard>-->
        <!--</VDialog>-->
    </VContainer>
</template>

<script>
  import DoublesCard from "./DoublesCard";
  import BaseBtn from "../BaseBtn";
  export default {
    props:['get','post','eventId','event','division'],
    components: {ImageCropper: ()=> import (/* webpackChunkName: "image"*/ '../images/ImageCropper'), BaseBtn, DoublesCard},
    name: "MyRegistrationC",
    data() {
      return {
        registrations:undefined,
        playercarddialog:false,
        activeregistrant:false,
        shirtsize:undefined,
        avpnumber:'2536475',
        cellphone:undefined,
        sizes:['XXL', 'XL','L','M','S','XS'],
        regdata:['shirtsize','avpnumber','cellphone'],
        loading:false,
        cropperdialog:false
      }
    },
    watch:{
      playercarddialog(n,o){
        console.log(n,o)
        if(n){
          let r = this.activeregistrant.registrationdata
          this.shirtsize = r.shirtsize
          this.avpnumber = r.avpnumber
          this.cellphone = r.cellphone
        }else {
          this.shirtsize =  undefined
          this.avpnumber = undefined
          this.cellphone = undefined
        }
      }
    },
    mounted() {
      this.getMyRegistration()
    },
    methods: {
      openCard(p){
        this.activeregistrant = p;
        this.playercarddialog = true
      },
      async getMyRegistration(){
        this.registrations = await this.get({path:'api/event/myteamsbyevent/'+this.eventId})
      },
      async saveData(){
        let data = {
          id:this.activeregistrant.id,
          shirtsize:this.shirtsize,
          avpnumber:this.avpnumber,
          cellphone:this.cellphone
        }
        this.loading=true
        let p = await this.post({path:'api/event/registrantinfo',body:data})
        this.loading=false
        if(p[0]===1){
          this.getMyRegistration()
          this.playercarddialog = false
        }
      }
    }
  }
</script>

<style scoped>

</style>